export const is_usZipCode = (value: string) => {
	const regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;

	return regexp.test(value);
}
